module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
      name: "ServiceList",
      path: "services/service_list",
      component: () => import('./service_list/service_list.vue'),
   }, ]
}